import DialogAlert from "components/DialogAlert/v2";
import CloseButton from "components/CloseButton/CloseButton";
import actionImage from "img/action_image.svg";
import { Container, Content, Footer } from "./styles";

const DialogAlertAction = ({
    dialog,
    title, content, contentComponent, 
    noImage = false, 
    variant, children, close, 
    minWidth, width = "600px",
    widthContent,
    spacingContainer
}) => {
    return (
        <DialogAlert
			dialog={dialog}
            closeDialog={close}
            width={width}>
            <CloseButton 
                color="var(--light-blue-4)" 
                onClick={close ?? dialog.hide}/>
            <Container minWidth={minWidth} gap={spacingContainer}>
                <Content 
                    className={contentComponent ? "content-component" : ""}
                    width={widthContent}>
                    {!noImage && <img src={actionImage} alt="Imagen de una acción UTP"/>}
                    {title && <h3 className={variant}>{title}</h3>}
                    {contentComponent 
                        ? contentComponent 
                        : <p className="paragraph center">{content}</p>}
                </Content>
                <Footer>
                    {children}
                </Footer>
            </Container>
        </DialogAlert>
    );
}

export default DialogAlertAction;